var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0.5C8.5 0.223858 8.27614 0 8 0C7.72386 0 7.5 0.223858 7.5 0.5V11.3866L3.83219 8.1263C3.6258 7.94284 3.30976 7.96143 3.1263 8.16782C2.94284 8.37422 2.96143 8.69025 3.16782 8.87371L7.66626 12.8723C7.74882 12.9464 7.85613 12.9934 7.97427 12.9993C7.98279 12.9998 7.99137 13 8 13C8.01051 13 8.02094 12.9997 8.03129 12.999C8.12291 12.9934 8.20785 12.963 8.27955 12.9146C8.29801 12.9021 8.3156 12.8885 8.33219 12.8737L12.8322 8.87371C13.0386 8.69025 13.0572 8.37422 12.8737 8.16782C12.6903 7.96143 12.3742 7.94284 12.1678 8.1263L8.5 11.3866V0.5Z",
    fill: "#9FA7AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.5C0 15.2239 0.223858 15 0.5 15H15.5C15.7761 15 16 15.2239 16 15.5C16 15.7761 15.7761 16 15.5 16H0.5C0.223858 16 0 15.7761 0 15.5Z",
    fill: "#9FA7AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportPdf);
export default __webpack_public_path__ + "static/media/import-pdf.aa7277d7acfa187c778363cb3dc25cb8.svg";
export { ForwardRef as ReactComponent };